module.exports = __webpack_public_path__ + "static/media/bowen-32.d62a2b9f.jpg";